import styled from 'styled-components';
import { ISSUE_STATUSES } from '../../../../state/issue.statuses';

const StyledStatusCell = styled.div`
  padding: 0.5rem 1rem;
  width: fit-content;
  border: 1px solid ${({ color }) => color};
  border-radius: 1.5rem;
  color: ${({ color }) => color};
`;

const StatusCell = ({ statusKey }) => {
  const status = ISSUE_STATUSES[statusKey];
  if (!status) return 'N/A';

  const { name, color } = status;

  return <StyledStatusCell color={color}>{name}</StyledStatusCell>;
};

export default StatusCell;
